import type {Ref} from 'vue'
import {ref} from 'vue'
import {defineStore} from 'pinia'
import {sessionStorageOrFalse} from "@/util";

export const useSectionStateStore = defineStore('sectionState', () => {
    const openSections: Ref<string[]> = ref([]);
    const close = (id: string) => {
        openSections.value = openSections.value.filter(value => value !== id);
    }
    const open = (id: string) => {
        openSections.value.push(id);
    }

    const toggle = (add: boolean, id: string) => {
        if (add) {
            open(id);
        } else {
            close(id);
        }
    }

    const isOpen = (id: string) => {
        return openSections.value.includes(id);
    }

    return {
        openSections, open, close, toggle, isOpen
    }
}, {persist: sessionStorageOrFalse()})
